import React from 'react';
import { motion } from 'framer-motion';
import './JustPage.css';
import { isJustDomain, MAIN_SITE_URL } from '../utils/justDomain';

const JustPage = () => {
  return (
    <div className="just-page">
      <meta name="robots" content="noindex, nofollow" />

      <div className="just-background">
        <div className="just-gradient-orb" />
      </div>

      <motion.div
        className="just-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="just-header">
          <img
            src="/images/logo.png"
            alt="Performer/AI"
            className="just-logo"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>

        <h1 className="just-title">
          Just.дисплей завершил переход в Performer/AI
        </h1>

        <div className="just-message liquid-glass">
          <p>
            Благодарим за то, что выбирали нас. С Вами мы проделали длинный путь
            от школьного проекта к стартапу. Технологии just.дисплея переродились
            в большее, чем digital signage — цифровых аватаров Performer/AI.
          </p>
          <p>
            С 1 июня 2026 личный кабинет и удалённое управление более недоступны.
            Ваши приставки и телевизоры перейдут в офлайн-режим.
          </p>
          <p>
            Вы можете связаться с нашей командой для выгрузки файлов, утилизации
            устройств или для запроса возврата средств. Для клиентов just.дисплея
            мы будем рады предложить скидки на наш новый продукт.
          </p>
        </div>

        <div className="just-buttons">
          <a
            href={isJustDomain() ? MAIN_SITE_URL : '/'}
            className="just-btn just-btn-primary"
          >
            Посмотрите, как мы изменились
          </a>
          <a href="mailto:gleb@performerai.ru" className="just-btn just-btn-secondary">
            Связаться с поддержкой
          </a>
        </div>

        <p className="just-email">
          <a href="mailto:gleb@performerai.ru">gleb@performerai.ru</a>
        </p>

        <div className="just-avatars liquid-glass">
          <h2 className="just-avatars-title">Цифровые аватары Performer/AI</h2>
          <p>
            Сенсорная панель с цифровым аватаром создаёт ощущение живого общения —
            интуитивно, экономично и технологично. Адаптивный ИИ на базе LLM
            полностью настраивается под вашу компанию без программирования:
            консультант, HR-ассистент, гид или презентатор на экране в офисе,
            торговом зале или на мероприятии.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default JustPage;
